
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","transform":"translate(2.004 2)"}},[_c('circle',{attrs:{"cx":"8","cy":"8","r":"8.75","stroke":"currentColor","stroke-width":"1.5"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-width":"1.5","d":"M13.986 8.976c-.628.057-1.24-.076-2.003-.36l-.257-.097c-1.084-.412-1.592-.483-2.423-.206-.768.257-1.513.24-2.395.019-.282-.07-.457-.124-1.002-.297-1.797-.572-2.692-.587-3.96.324a6.065 6.065 0 0012.04.617z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M3.51 3.274A6.496 6.496 0 018 1.48c1.19 0 2.305.32 3.265.876a5.755 5.755 0 00-2.524-.58 5.767 5.767 0 00-4.533 2.195l-.697-.698z"}})])])
          )
        }
      }
    